// extracted by mini-css-extract-plugin
module.exports = {"container":"PageContainer_container__1TUET","fullWidth":"PageContainer_fullWidth__RU5GM"};